module.exports = __webpack_public_path__ + "img/symbol_8.cb2c6e3f.png";